exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._32CiPXdv6sbe36uhVCJU-U{min-width:80px;min-height:32px}html[dir] ._32CiPXdv6sbe36uhVCJU-U{border-radius:2px}html[dir=ltr] ._32CiPXdv6sbe36uhVCJU-U{margin-right:8px}html[dir=rtl] ._32CiPXdv6sbe36uhVCJU-U{margin-left:8px}", ""]);
// Exports
exports.locals = {
	"actionButton": "_32CiPXdv6sbe36uhVCJU-U"
};